export default __webpack_public_path__ + "static/media/miguel-lopes-5.78b63108.jpg";